export enum MessageType {
  SYSTEM = "system",
  SYSTEM_ONLY = "system-only",
  USER = "user",
}

export interface SocketMessage {
  id: string;
  channel: string;
  sender: string;
  sender_id: string;
  video_id: string;
  content: {
    code: string;
    expires: string;
    hidden: boolean;
    message: string;
    msg_type: MessageType;
    pinned: boolean;
    meta_info?: {
      message_id: string;
      reporting_username: string;
      username: string;
    };
  };
}

export interface Sticker {
  created_at: string;
  file_name: string;
  sticker_id: string;
  value: string;
}
